module.exports = __webpack_public_path__ + "img/1522362401.8693083a.jpg";